export default __webpack_public_path__ + "static/media/grimcorruption4.e5c2e093.png";